/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Track_EndInputs */

const en_cp_track_end = /** @type {(inputs: Cp_Track_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finale`)
};

const id_cp_track_end = /** @type {(inputs: Cp_Track_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puncak`)
};

/**
* | output |
* | --- |
* | "Finale" |
*
* @param {Cp_Track_EndInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_track_end = /** @type {((inputs?: Cp_Track_EndInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Track_EndInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_track_end(inputs)
	return en_cp_track_end(inputs)
});